module.exports = __webpack_public_path__ + "static/media/fontfamily.16824ae5.svg";